import React, { Component } from "react";

import { Redirect } from "react-router";

class NotFound extends Component {
    render() {
        // return <Redirect to="/" />;
       return window.location.href = "/";
    }
}

export default NotFound;
